import '@angular/localize/init';
export * from './lib/feature-tax-workflow-list.module';

export * from './lib/tax-workflow-list/feature-tax-workflow-list.component';
